import React from 'react';
import priceFormat from '../../utils/showPriceFormat';
import './ShopItem.css';

const ShoppingCartItem = ({id, title, unit, ourPrice, count, minValue, setShoppingCart, setShopItems}) => {

    const incrementEventHandler = () =>  {
        setShoppingCart(id, 'INCREMENT', minValue)
        setShopItems(id, 'INCREMENT', minValue);
    }

    const decrementValueHandler = () => {
        setShoppingCart(id, 'DECREMENT', minValue)
        setShopItems(id, 'DECREMENT', minValue)
    }
    return ( 
        <div className='shopping-cart-item shadow-sm'>
            <div className='row  justify-content-between'>
                <div className='col-8 row align-items-center'>
                    <div className='col-12 col-md-7 font-weight-bold'>{title}</div>
                    <div className='col-12 col-md-5 text-right' style={{fontSize:'.8rem'}}>
                        {priceFormat(count * ourPrice)} تومان
                    </div>
                </div>
                <div className='col-4 d-flex justify-content-end align-self-center'>
                    <button className='btn btn-sm btn-success d-flex justify-content-center align-items-center'
                        style={{ width: '27px', height: '27px' }}
                        onClick={incrementEventHandler}
                    >
                        <i className='fa fa-plus'></i>
                    </button>
                    <span className='mx-1 font-weight-bold'>
                        {count}
                        <span style={{ fontSize: '.8rem', marginRight: '4px' }}>{unit}</span>
                    </span>
                    <button className='btn btn-sm btn-danger d-flex justify-content-center align-items-center'
                        style={{ width: '27px', height: '27px' }}
                        onClick={decrementValueHandler}
                    >
                        <i className='fa fa-minus'></i>
                    </button>
                </div>
            </div>
        </div>
    );
}
 
export default ShoppingCartItem;